export let addFavoriteLabel = "VmRKsd";
export let hideFavoritesLabel = "bD18Gd";
export let newFavoritePickedText = "z4Grzc";
export let renameFavoriteLabel = "qpB7De";
export let pinFavoritesLabel = "YW_Gpd";
export let unpinFavoritesLabel = "tzAKh";
export default {addFavoriteLabel,hideFavoritesLabel,newFavoritePickedText,renameFavoriteLabel,pinFavoritesLabel,unpinFavoritesLabel};